import { SET_PROFILE, SET_WALLET_STATS, UPDATE_PROFILE, SET_FETCHING, SET_WALLET } from "@stofloos/actions/profile";

const initialState = {
	profile: null,
	wallet: null,
	error: false,
	message: null,
	isFetching: false,
	hasFetched: false
};

const StofwareProfile = (state = initialState, action) => {
	switch (action.type) {
		case SET_FETCHING:
			return {
				...state,
				isFetching: action.isFetching
			};
		case UPDATE_PROFILE:
		case SET_PROFILE:
			return {
				...state,
				profile: action.profile,
				isFetching: false,
				message: null,
				error: false
			};
		case SET_WALLET: {
			return {
				...state,
				wallet: action.wallet,
				isFetching: false,
				message: null,
				error: false
			};
		}
		case SET_WALLET_STATS:
			return {
				...state,
				gamification: action.gamification,
				isFetching: false,
				message: null,
				error: false
			};
		default:
			return state;
	}
};

export default StofwareProfile;
